<template>
  <div>
    <head-nav-bar title="签名" :fixed="true" />
    <div class="mt-header-nav">
      <div class="sign-panel">
        <div class="sign-inner">
          <vue-esign
            ref="esign"
            :height="300"
            :isCrop="isCrop"
            :lineWidth="lineWidth"
            :lineColor="lineColor"
          />
        </div>
        <div class="sign-tip">*请在空白处签名</div>
      </div>

      <van-goods-action>
        <van-row type="flex" justify="space-between" style="width:100%">
          <van-col :span="8">
            <van-button block @click="back">
              取消
            </van-button>
          </van-col>
          <van-col :span="8">
            <van-button type="danger" block @click="handleReset">
              清除
            </van-button>
          </van-col>
          <van-col :span="8">
            <van-button type="info" block @click="handleGenerate">
              完成
            </van-button>
          </van-col>
        </van-row>
      </van-goods-action>
    </div>
  </div>
</template>

<script>
import "./sign.less";
import { uploadImage } from "@/api/sign.js";
import Vue from "vue";
import vueEsign from "vue-esign";
Vue.use(vueEsign);
import { Button, Panel, GoodsAction, Row, Col } from "vant";
export default {
  components: {
    [Button.name]: Button,
    [Panel.name]: Panel,
    [Row.name]: Row,
    [Col.name]: Col,
    [GoodsAction.name]: GoodsAction,
  },
  data() {
    return {
      orderId: "",
      type: 0,
      lineWidth: 4,
      lineColor: "#000000",
      resultImg: "",
      isCrop: true,
    };
  },
  created() {
    this.orderId = this.$route.query.orderId;
    this.type = this.$route.query.type;
  },
  methods: {
    handleReset() {
      this.$refs.esign.reset();
    },
    handleGenerate() {
      this.$refs.esign
        .generate()
        .then(res => {
          this.resultImg = res;
          const img = this.resultImg.split(",")[1];
          uploadImage({
            type: this.type,
            orderId: this.orderId,
            base64Image: img,
          }).then(() => {
            this.back();
          });
        })
        .catch(err => {
          alert(err); // 画布没有签字时会执行这里 'Not Signned'
        });
    },
    back() {
      if (this.type == 1) {
        this.$router.push({
          name: "signAccountBill",
          query: {
            id: this.orderId,
          },
        });
      } else if (this.type == 0) {
        this.$router.push({
          name: "signRegisterBill",
          query: {
            id: this.orderId,
          },
        });
      }
    },
  },
};
</script>

<style lang="less" scoped></style>
